import markScreenSelected from '../../gateways/browser/mark_screen_selected';

const ProfileController = function ($scope, brandingInteractor) {
  const $ctrl = this;

  // console.log("ProfileController");

  brandingInteractor.loadDefaultBranding().then(data => {
    $ctrl.defaultBranding = brandingInteractor.defaultBranding;
    $ctrl.availableFonts = data.possible_fonts;
    $scope.$digest();
  });

  markScreenSelected();

};

export default {
  name: "ProfileController",
  fn: ProfileController
}